import React, { useState, useEffect } from "react";
// date picker context component
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import brLocale from "date-fns/locale/pt-BR";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
// Legacy styles (mantido para compatibilidade)
import GlobalStyles from "~/presentation/themes/styles.App";
// Modern theme and styles
import { modernTheme } from "~/presentation/themes/modernTheme";
import ModernGlobalStyles from "~/presentation/themes/modernGlobalStyles";
// routes
import RoutesMain from "~/presentation/routes/index";
// context
import AppContext from "~/presentation/AppContext";
// error boundary
import ErrorBoundary from "~/presentation/components/ErrorBoundary/ErrorBoundary";
// styles
import { makeAuthenticationUseCases } from "./factories/use-cases/authentication";
//context providers
import { SnackbarProvider } from "~/presentation/providers/SnackbarProvider";
import { BackdropProvider } from "~/presentation/providers/BackdropProvider";
import { DialogProvider } from "~/presentation/providers/DialogProvider";

function App() {
  const [user, setUser] = useState();
  const [didLogin, setDidLogin] = useState(true); //importante para renderizar o app quando existe Login novo
  const authenticationUseCases = makeAuthenticationUseCases();

  useEffect(() => {
    if (!localStorage.GT_user) {
      localStorage.clear();
    }
  }, [localStorage]);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "xrlsgtk503");
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (user?.id && typeof window.clarity === "function") {
      window.clarity("identify", user.id);
      window.clarity("set", "nome", user.name);
      window.clarity("set", "empresa", user.companyInfor?.name);
    }
  }, [user]);

  const handleLogout = () => {
    authenticationUseCases.logout();
    setUser(null);
  };

  const handleLogin = async (values) => {
    return authenticationUseCases.auth(values);
  };

  const isLogged = () => {
    return authenticationUseCases.isLogged();
  };

  const contextValues = {
    user,
    setUser,
    handleLogin,
    handleLogout,
    isLogged,
    didLogin,
    setDidLogin,
  };

  return (
    <AppContext.Provider value={contextValues}>
      <ThemeProvider theme={modernTheme}>
        <CssBaseline />
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={brLocale}
          localeText={{
            fieldYearPlaceholder: () => "AAAA",
          }}
        >
          <BackdropProvider>
            <SnackbarProvider>
              <DialogProvider>
                {/* Legacy styles para compatibilidade */}
                <GlobalStyles />
                {/* Modern styles */}
                <ModernGlobalStyles />
                <ErrorBoundary>
                  <RoutesMain />
                </ErrorBoundary>
              </DialogProvider>
            </SnackbarProvider>
          </BackdropProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </AppContext.Provider>
  );
}

export default App;
